import {
  SystemPreferenceKeys,
  type SystemPreferenceKeysEnum,
} from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'

const systemPreferencesQueryKey = 'system-preferences'

// ['system-preferences', key]: the key `systemPreferenceQueryConfig.getValue`
// reads under; the named entries below alias it for invalidation and tests.
const byKey = <K extends SystemPreferenceKeysEnum>(key: K) =>
  [systemPreferencesQueryKey, key] as const

export const systemPreferencesKeys = {
  all: [systemPreferencesQueryKey] as const,
  byKey,
  defaultDisclaimer: byKey(SystemPreferenceKeys.DEFAULT_DISCLAIMER),
  externalPONumbering: byKey(SystemPreferenceKeys.AUTO_PO_CUSTOM_SEQUENCE),
  listMFASystemPreference: byKey(
    SystemPreferenceKeys.MULTI_FACTOR_AUTHENTICATION
  ),
  organizationName: byKey(SystemPreferenceKeys.ORGANIZATION_NAME),
  poBillToContact: byKey(SystemPreferenceKeys.PO_BILL_TO_CONTACT),
  poBillToPrimaryCategory: byKey(SystemPreferenceKeys.PO_BILL_TO_LOCATION),
  poPdfHiddenCustomFields: byKey(
    SystemPreferenceKeys.PO_PDF_CUSTOM_FIELDS_HIDDEN
  ),
  vendorInviteBatchLimit: byKey(SystemPreferenceKeys.VENDOR_INVITE_BATCH_LIMIT),
}
